// extracted by mini-css-extract-plugin
export default {"wrapper":"Token_wrapper__RxTbV","content":"Token_content__sfvmy","title":"Token_title__JdfyD","icon":"Token_icon__9FcVQ","text":"Token_text__csszh"};